module.exports = __webpack_public_path__ + "img/header-8.497cd731.jpg";